import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class AccountingSettingsSaveService {

  public isSaving$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public saveEmitted(): void {
    this.isSaving$.next(true);
  }

  public saveFinished(): void {
    this.isSaving$.next(false);
  }


}
